/**
 *  convert.js 较大，素材库单独处理: 图片库，攻略库，视频库
 */
import { uniqueId, recursionTrans } from "../../common/util.js";
import { businessLangs } from "@/components/langSelect/languages.js";

/**********
 *  素材库标签管理
 ***********/

// 标签列表数据转换
function transTagTreesData(result) {
    return recursionTrans(
        result,
        function(treesData) {
            const isFirstAnswerScene = treesData.tag_id == 1 || treesData.tag_id == 1001;

            return {
                id: "" + treesData.tag_id,
                smallLabel: "共" + treesData.resource_count + "条",
                label: treesData.tag_name,
                editFlags: isFirstAnswerScene ? ["edit", "move"] : null
            };
        },
        "nodes",
        "children"
    );
}

// 错误信息转换
function cvtRequestErrorData(error) {
    return {
        errCode: error.err_code,
        errMessage: error.err_msg,
        result: error.result
    };
}

/**********
 *  图片库
 ***********/

// 图片库列表数据转换
function cvtPictureListData(result) {
    let data = {
        count: result.count,
        pictureData: []
    };
    data.pictureData =
        result &&
        result.list.map(item => {
            return {
                uId: uniqueId(),
                id: item.id,
                tagIds: item.tag_ids,
                title: item.name,
                updateTime: item.update_time,
                url: item.big_pic,
                amount: item.views,
                editor: item.editor,
                creator: item.creator,
                createTime: item.create_time,
                sourceType: item.source_type,
                relevanceStdQuestionIds: item.relevance_std_question_ids,
            };
        });
    return data;
}

// 单个图片数据转换
function cvtPictureItemData(result) {
    return {
        id: result.id,
        tagIds: result.tag_ids,
        title: result.name,
        updateTime: result.update_time,
        url: result.big_pic,
        amount: result.acc_exposure_times || 0,
        editor: result.editor,
        creator: result.creator,
        createTime: result.create_time,
        sourceType: result.source_type
    };
}

// 多图上传数据转换
function cvtMulitImportImg(result) {
    let ret = [];
    ret = result.url.map(item => {
        return {
            uId: uniqueId(),
            name: item.image_name,
            imgUrl: item.image_url,
            imgTags: ""
        };
    });

    return ret;
}

// 图片列表服务端数据格式
function imgList2ServerParam(reqData) {
    const sequence = { updateTime: 3, readVolume: 0 };

    let request = {
        image_name: reqData.pictureName || "",
        image_id: reqData.pictureId || "",
        editor: reqData.editor || "",
        tag_id: reqData.tagId || "",
        page: reqData.page || "",
        size: reqData.size || "",
        sort: reqData.sequence ? sequence[reqData.sequence] : 3,
        is_relevance_answer: reqData.usageStatus || ""
    };

    return request;
}

// 新增单个图片服务端格式
function singleImg2ServerParam(reqData, localCaches) {
    let request = {
        name: reqData.pictureName,
        card_name: reqData.pictureName,
        big_pic: reqData.cardImage,
        tag_ids: reqData.pictureTag || "",
        creator: reqData.creator != undefined ? reqData.creator : localCaches.editor
    };

    return request;
}

// 批量新增VLink图片服务端数据格式
function multiImg2ServerParam(reqData) {
    let reqArr = [];
    reqArr = reqData.map(item => {
        return {
            name: item.name,
            big_pic: item.imgUrl,
            tag_ids: item.imgTags
        };
    });

    return JSON.stringify(reqArr);
}

// 更新单个图片服务端数据格式
function updateImg2ServerParam(reqData) {
    let request = {
        name: reqData.pictureName,
        card_name: reqData.pictureName,
        big_pic: reqData.cardImage,
        card_pic: reqData.cardImage,
        tag_ids: reqData.pictureTag || "",
        id: reqData.pictureId
    };

    return request;
}

/**********
 *  视频库
 ***********/

// VLink视频列表服务端数据格式
function VLinkVideoList2Server(reqData) {
    const sourceObj = { all: 0, self: 1 };
    const sequence = { updateTime: 3, readVolume: 2 };

    let request = {
        video_name: reqData.videoName || "",
        video_id: reqData.videoId || "",
        editor: reqData.editor || "",
        tag_id: reqData.tagId || "",
        source: reqData.source ? sourceObj[reqData.source] : 0,
        page: reqData.page || "",
        size: reqData.size || "",
        sort: reqData.sequence ? sequence[reqData.sequence] : 3,
        lang: reqData.lang && reqData.lang !== "all" ? reqData.lang : "",
        is_relevance_answer: reqData.usageStatus || ""
    };

    return request;
}

// VLink视频库列表客户端数据转换
function VLinkVideoList2Client(result) {
    let data = {
        count: result.count,
        videoData: []
    };
    data.videoData =
        result &&
        result.list.map(item => {
            return {
                id: item.id,
                tagIds: item.tag_ids,
                title: item.name,
                platformTitle: item.name_platform,
                updateTime: item.update_time,
                url: item.big_pic,
                amount: item.views,
                editor: item.editor,
                creator: item.creator,
                createTime: item.create_time,
                sourceType: item.source_type,
                videoUrl: item.video_url,
                videoSize: item.video_size,
                videoId: item.video_id,
                duration: item.video_duration,
                isLove: item.sort, //是否是推荐视频
                lang: item.lang,
                videoLabel: item.title,
                playNumber: item.base_views,
                likeNumber: item.base_like_num,
                showDate: item.view_date,
                relevanceStdQuestionIds: item.relevance_std_question_ids,
            };
        });

    return data;
}

// vlink单个视频详情数据客户端数据转换
function vlinkVideo2Client(result) {
    return {
        id: result.id,
        tagIds: result.tag_ids,
        title: result.name,
        updateTime: result.update_time,
        url: result.big_pic,
        amount: result.views || 0,
        editor: result.editor,
        creator: result.creator,
        createTime: result.create_time,
        sourceType: result.source_type,
        videoUrl: result.video_url,
        videoSize: result.video_size,
        videoId: result.video_id,
        duration: result.video_duration,
        lang: result.lang
    };
}

// VLink视频服务端数据格式: 新增
function addVLinkVideo2Server(reqData, localCaches) {
    let request = {
        name_platform: reqData.platformTitle,
        name: reqData.videoName,
        card_name: reqData.videoName,
        big_pic: reqData.cardImage,
        tag_ids: reqData.videoTag || "",
        video_url: reqData.videoUrl,
        creator: reqData.creator != undefined ? reqData.creator : localCaches.editor,
        source_type: reqData.sourceType,
        video_id: reqData.videoId || "",
        video_duration: reqData.duration || "",
        video_size: reqData.videoSize || "",
        lang: reqData.lang,
        title: reqData.videoLabel,
        base_views: reqData.playNumber,
        base_like_num: reqData.likeNumber,
        view_date: reqData.showDate
    };

    return request;
}

// vlink视频服务端数据格式: 更新
function updateVlinkVideo2Server(reqData) {
    let request = {
        name_platform: reqData.platformTitle,
        name: reqData.videoName,
        card_name: reqData.videoName,
        big_pic: reqData.cardImage,
        card_pic: reqData.cardImage,
        tag_ids: reqData.videoTag || "",
        video_url: reqData.videoUrl,
        id: reqData.id,
        video_id: reqData.videoId || "",
        video_duration: reqData.duration || "",
        video_size: reqData.videoSize || "",
        lang: reqData.lang,
        title: reqData.videoLabel,
        base_views: reqData.playNumber,
        base_like_num: reqData.likeNumber,
        view_date: reqData.showDate
    };

    return request;
}

/**********
 *  攻略库
 ***********/

// VLink攻略列表服务端数据格式
function vlinkGuideList2Server(reqData) {
    const sourceObj = { all: 0, self: 1 };
    const sequence = { updateTime: 3, readVolume: 2 };

    let request = {
        tip_name: reqData.tipName || "",
        tip_id: reqData.tipId || "",
        editor: reqData.editor || "",
        tag_id: reqData.tagId || "",
        source: reqData.source ? sourceObj[reqData.source] : 0,
        page: reqData.page || "",
        size: reqData.size || "",
        sort: reqData.sequence ? sequence[reqData.sequence] : 3,
        lang: reqData.lang && reqData.lang !== "all" ? reqData.lang : "",
        is_relevance_answer: reqData.usageStatus || ""
    };

    return request;
}

// vlink攻略列表客户端数据格式转换
function vlinkGuideList2Client(result) {
    let data = {
        count: result.count,
        strategyData: []
    };
    data.strategyData =
        result.list.length > 0 &&
        result.list.map(item => {
            return {
                id: item.id,
                tagIds: item.tag_ids,
                title: item.name,
                platformTitle: item.name_platform,
                content: item.content_format == 1 ? item.content && cvtGuideContent(JSON.parse(item.content)) : item.content,
                contentFormat: item.content_format,
                updateTime: item.update_time,
                url: item.big_pic,
                amount: item.views,
                editor: item.editor,
                creator: item.creator,
                createTime: item.create_time,
                sourceType: item.source_type,
                isLove: item.sort, //是否是推荐攻略
                lang: item.lang,
                strategyLabel: item.title,
                playNumber: item.base_views,
                likeNumber: item.base_like_num,
                showDate: item.view_date,
                relevanceStdQuestionIds: item.relevance_std_question_ids,
            };
        });

    return data;
}

// VLink攻略客户端数据格式转换
function vlinkGuides2Client(result) {
    return {
        id: result.id,
        tagIds: result.tag_ids,
        title: result.name,
        content: result.content_format == 1 ? result.content && cvtGuideContent(JSON.parse(result.content)) : result.content,
        contentFormat: result.content_format,
        updateTime: result.update_time,
        url: result.big_pic,
        amount: result.views || 0,
        editor: result.editor,
        creator: result.creator,
        createTime: result.create_time,
        sourceType: result.source_type,
        lang: result.lang
    };
}

// 攻略内容客户端数据转换
function cvtGuideContent(content) {
    let ret = [];
    const widgetType = {
        image: "GuidePicture",
        text: "GuideText"
    };
    ret =
        content &&
        content.map(item => {
            return {
                uId: uniqueId(),
                updateState: "add",
                wtType: widgetType[item.div_item[0].type],
                image: item.div_item[0].image,
                content: item.div_item[0].content.replace(/\n/g, "<br/>"),
                float: "mid"
            };
        });

    return ret;
}

// vlink新增攻略服务端数据格式
function addVlinkGuide2Server(reqData, localCaches) {
    let request = {
        name_platform: reqData.platformTitle,
        name: reqData.strategyName,
        card_name: reqData.strategyName,
        big_pic: reqData.cardImage,
        card_pic: reqData.cardImage,
        tag_ids: reqData.strategyTag || "",
        lang: reqData.lang,
        content: reqData.formatType === 1 ? JSON.stringify(guideContent2Serve(reqData.guideContent)) : reqData.guideContent,
        creator: reqData.creator != undefined ? reqData.creator : localCaches.editor,
        source_type: 0, // 0 -> 小悦
        content_format: reqData.formatType, // 1 json格式 0 html格式
        title: reqData.strategyLabel,
        base_views: reqData.playNumber,
        base_like_num: reqData.likeNumber,
        view_date: reqData.showDate
    };

    return request;
}

// vlink攻略内容(json)服务端数据格式转换
function guideContent2Serve(content) {
    let ret = [];
    const widgetType = {
        GuidePicture: "image",
        GuideText: "text"
    };
    ret = content.map(item => {
        return {
            div_item: [
                {
                    type: widgetType[item.wtType],
                    image: item.image,
                    content: item.content.replace(/<br\/>/g, "\n"),
                    float: "mid"
                }
            ]
        };
    });

    return ret;
}

// vlink攻略服务端数据格式： 更新
function updateVlinkGuide2Server(reqData) {
    let request = {
        name_platform: reqData.platformTitle,
        name: reqData.strategyName,
        card_name: reqData.strategyName,
        big_pic: reqData.cardImage,
        card_pic: reqData.cardImage,
        tag_ids: reqData.strategyTag || "",
        id: reqData.id,
        lang: reqData.lang,
        content: reqData.formatType === 1 ? JSON.stringify(guideContent2Serve(reqData.guideContent)) : reqData.guideContent,
        source_type: 0, // 0 -> 小悦
        content_format: reqData.formatType, // 1 json格式 0 html格式
        title: reqData.strategyLabel,
        base_views: reqData.playNumber,
        base_like_num: reqData.likeNumber,
        view_date: reqData.showDate
    };

    return request;
}

// 素材库标签-多语种名称前端数据转换
function multiLanguage2Client(result) {
    let ret = [];
    ret = businessLangs().map(lang => {
        return {
            uId: uniqueId(),
            value: lang.lang,
            i18nKey: lang.i18nKey,
            name: result[lang.lang] || ""
        };
    });
    return ret;
}

// 素材库标签-编辑多语种名称接口参数
function saveMultiLanguageParams(reqData) {
    let multiLangData = {};
    reqData.multiLanguage.map(item => {
        item.name && (multiLangData[item.value] = item.name);
    });
    return {
        tag_id: reqData.tagId,
        multi_language: JSON.stringify(multiLangData)
    };
}

export default {
    transTagTreesData,
    cvtRequestErrorData,
    cvtPictureListData,
    cvtPictureItemData,
    imgList2ServerParam,
    vlinkGuideList2Client,
    vlinkGuides2Client,
    VLinkVideoList2Client,
    vlinkVideo2Client,
    singleImg2ServerParam,
    updateImg2ServerParam,
    VLinkVideoList2Server,
    addVLinkVideo2Server,
    updateVlinkVideo2Server,
    vlinkGuideList2Server,
    addVlinkGuide2Server,
    updateVlinkGuide2Server,
    cvtMulitImportImg,
    multiImg2ServerParam,
    multiLanguage2Client,
    saveMultiLanguageParams
};
